import styled from '@emotion/styled'
import { List, ListItem, Avatar } from 'flipper-ui'
import { theme } from 'flipper-ui/theme'

const { neutral } = theme.colors

export const ANCHOR_ORIGIN = {
    horizontal: 'center',
    vertical: 'bottom'
} as const

export const TRANSFORM_ORIGIN = {
    horizontal: 'center',
    vertical: 'top'
} as const

export const AvatarContainer = styled(Avatar)`
    width: 34px;
    height: 34px;
`

export const CustomList = styled(List)`
    && {
        outline: none;
        background-color: ${neutral[50]};
        overflow-y: hidden;
    }
`

export const UserListItems = styled(ListItem)`
    & div > span {
        line-height: 1em !important;
    }

    & div > p {
        line-height: 1em !important;
    }

    & .MuiListItemAvatar-root {
        min-width: 44px !important;
    }
`
